export const TUTOR_BOOKING_NEEDS_ACTION_COUNT_CHANGED_EVENT =
  'tutor-booking-needs-action-count-changed';

export function notifyTutorBookingNeedsActionCountChanged(): void {
  window.dispatchEvent(new Event(TUTOR_BOOKING_NEEDS_ACTION_COUNT_CHANGED_EVENT));
}
